export const listItemClassName = 'px-4 py-2 transition-colors';
export const linkClassName = 'text-body hover:no-underline focus:no-underline';
export const listItemActiveClassName =
  'bg-primary-300 text-primary-700 hover:text-primary-700';
export const listItemHoverClassName =
  'hover:bg-primary-300 hover:text-primary-700';
